import { RecordingInProgressType, RecordingMetadata, RecordingMetadataBody } from 'api/types';

export const checkRecordingInProgress = (metadata: object): metadata is RecordingInProgressType => {
    return 'initiatorId' in metadata;
};

export const checkRecordingDataInMetadata = (metadata: object | null) => {
    return metadata !== null && 'egress' in metadata;
};

export const parseRecordingDataFromMetadata = (
    metadata: Partial<RecordingMetadata> | { egress?: RecordingMetadataBody } | null,
) => {
    return metadata?.egress || null;
};
